import * as $ from 'jquery';
import 'owl.carousel';

import store from '../../../js/store';

const $carousel = $('.alumni-list');

if($carousel.length > 0) {
  $carousel.owlCarousel({
    items: 1,
    dots: true,
    nav: true,


    onInitialized: (function(e) {
      const $elem = this.$element;

      $elem.addClass('owl-carousel');
      $('.owl-dots, .owl-nav, .cloned', $elem).attr({
          'aria-hidden': true,
          'role'       : 'presentation',
      });

      $elem.append(`<div class="owl-move">`);

      const $move = $('.owl-move', $elem);
      $move.append($('.owl-dots', $elem), $('.owl-nav', $elem));

      $('.owl-nav .owl-prev', $elem).unwrap();
    }),

    responsive: {
      [parseInt(store.constants['sprout-breakpoints'].medium)] : {
        items: 2,
      },

      [parseInt(store.constants['sprout-breakpoints'].large)] : {
        items: 3,
      }
    },

    navText     : [
      `<svg role="presentation" title="Previous" class="icon icon--arrow_left">
        <use xlink:href="#arrow_left"></use>
      </svg>`,
      `<svg role="presentation" title="Next" class="icon icon--arrow_right">
        <use xlink:href="#arrow_right"></use>
      </svg>`,
    ],
  })
}
